// Generated by scripts/write-build-info.js
const BUILD_COMMIT_HASH = '46d9989';

export default BUILD_COMMIT_HASH;
